import React from "react";

const SkeletonMatchRow = () => {
  return (
    <div className="border-t border-solid border-gray-300 dark:border-gray-700 p-2">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <div className="h-5 w-40 bg-gray-300 dark:bg-darktitleColor rounded"></div>
          <div className="ml-2 h-5 w-16 bg-gray-300 dark:bg-darktitleColor rounded"></div>
        </div>
        <div className="h-5 w-24 bg-gray-300 dark:bg-darktitleColor rounded"></div>
      </div>
      <div className="flex justify-between">
        {Array(8)
          .fill(0)
          .map((_, i) => (
            <div
              key={i}
              className="w-12 h-10 bg-gray-300 dark:bg-darktitleColor rounded flex items-center justify-center"
            ></div>
          ))}
      </div>
    </div>
  );
};

const SkeletonLeagueItem = () => {
  return (
    <div className="mb-4">
      <div className="bg-gray-200 dark:bg-darktitleColor p-4 flex items-center justify-between">
        <div className="h-6 w-64 bg-gray-300 dark:bg-darktitleColor rounded"></div>
        <div className="h-6 w-6 bg-gray-300 dark:bg-darktitleColor rounded"></div>
      </div>
      {Array(5)
        .fill(0)
        .map((_, i) => (
          <SkeletonMatchRow key={i} />
        ))}
    </div>
  );
};

const SportBetSkeleton = ({ isDarkMode }) => {
  return (
    <div className="rounded-lg bg-white dark:bg-bluedarkmode shadow-lg overflow-hidden">
      {/* Header section */}
      <div className="bg-white dark:bg-bluedarkmode border-b border-gray-300 dark:border-gray-800">
        <div className="flex items-center justify-between px-5 py-4">
          <div className="h-7 w-24 bg-gray-300 dark:bg-darktitleColor rounded"></div>

          {/* Day selector skeleton */}
          <div className="flex space-x-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="h-10 w-16 bg-gray-300 dark:bg-darktitleColor rounded flex items-center justify-center"
              >
                {i === 1 && (
                  <div className="h-5 w-12 bg-gray-200 dark:bg-darktitleColor rounded"></div>
                )}
              </div>
            ))}
            <div className="h-10 w-10 bg-gray-200 dark:bg-bluedarkmode rounded ml-2"></div>
          </div>
        </div>

        {/* Sport filter skeleton */}
        <div className="p-3 overflow-x-auto">
          <div className="flex space-x-3">
            {[
              { width: "w-24", count: "135" },
              { width: "w-20", count: "27" },
              { width: "w-28", count: "45" },
              { width: "w-24", count: "41" },
              { width: "w-24", count: "35" },
              { width: "w-24", count: "31" },
              { width: "w-20", count: "13" },
            ].map((item, i) => (
              <div
                key={i}
                className={`h-8 ${item.width} bg-gray-200 dark:bg-bluedarkmode rounded-full flex-shrink-0 flex items-center justify-between px-3`}
              >
                <div className="h-4 w-16 bg-gray-300 dark:bg-darktitleColor rounded"></div>
                <div className="h-5 w-8 bg-gray-300 dark:bg-darktitleColor rounded-full flex items-center justify-center text-xs">
                  {item.count}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Sort and display options skeleton */}
      <div className="border-b border-darktitleColor dark:border-darktitleColor">
        <div className="flex items-center justify-between py-3 px-5">
          <div className="flex items-center space-x-2">
            <div className="h-6 w-24 bg-gray-300 dark:bg-darktitleColor rounded"></div>
            <div className="h-6 w-6 bg-gray-300 dark:bg-darktitleColor rounded"></div>
          </div>

          <div className="bg-gray-300 dark:bg-darktitleColor h-8 w-12 rounded flex items-center justify-center">
            <div className="h-4 w-8 bg-gray-200 dark:bg-bluedarkmode rounded"></div>
          </div>

          <div className="flex items-center space-x-2">
            <div className="h-6 w-32 bg-gray-300 dark:bg-darktitleColor rounded"></div>
            <div className="h-6 w-6 bg-gray-300 dark:bg-darktitleColor rounded"></div>
          </div>

          <div className="bg-gray-300 dark:bg-darktitleColor h-8 w-12 rounded flex items-center justify-center">
            <div className="h-4 w-8 bg-gray-300 dark:bg-darktitleColor rounded"></div>
          </div>
        </div>

        <div className="px-5 py-2">
          <div className="h-6 w-full bg-gray-300 dark:bg-darktitleColor rounded"></div>
        </div>
      </div>

      {/* League list skeleton */}
      <div>
        <SkeletonLeagueItem />
        <SkeletonLeagueItem />
        <SkeletonLeagueItem />
      </div>
    </div>
  );
};

export default SportBetSkeleton;
